// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"h0-z"};